import styled, { css } from 'styled-components';
import { TextStyle } from 'components/text';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Wrapper = styled.div`
  display: grid;
  overflow: auto;
`;

export const Table = styled.table`
  min-width: 1100px;
  overflow: scroll;
  border-spacing: 0;

  tr {
    font-size: 14px;

    th {
      text-align: start;
      background-color: ${({ theme }) => theme.neutral_200};
      padding: 16px;
      white-space: nowrap;
    }

    th:first-child {
      border-radius: 8px 0px 0px 8px;
    }

    th:last-child {
      border-radius: 0px 8px 8px 0px;
    }
  }
`;

const TableData_negative = css`
  white-space: nowrap;
  color: ${({ theme }) => theme.danger_500};
`;

export const TableData = styled.td<{ $negative?: boolean }>`
  padding: 16px;
  max-width: 200px;

  ${TextStyle} {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  ${({ $negative }) => $negative && TableData_negative}
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  p {
    font-weight: 600;
    font-size: 20px;
    width: 250px;
    text-align: center;
  }
`;
